import { ExportAnnualReportExcel } from '../../../../aumico-lib-annualreport-fe/src/lib/interfaces/export-excel/annual-report-excel.interface';

export interface CompanyValuationRequestDTO {
    companyName: string;
    companyId: string;
    exportAnnualReportsExcels: ExportAnnualReportExcel[];
}
